import { theme as designSystemTheme } from '../ui'

export const theme = designSystemTheme
